// utils/api/DocumentEditorApi/index.js

import { aiApi } from './AIApi';
import { documentApi } from './DocumentApi';
import { tocApi } from './TocApi';
import { activityApi } from './ActivityApi';
import { aiGuidelineApi } from './AIGuidelineApi';
import { attachmentsApi } from './AttachmentsApi';

// Export individual APIs
export { aiApi, documentApi, tocApi, activityApi, aiGuidelineApi, attachmentsApi };

// Export embedded questions API separately to avoid circular dependency
export * as embeddedQuestionsApi from './EmbeddedQuestionsApi';

// Export unified API object for backward compatibility
export const documentEditorApi = {
  // AI endpoints
  ...aiApi,

  // Document and folder management endpoints
  ...documentApi,

  // Table of contents endpoints
  ...tocApi,

  // Activity tracking endpoints
  ...activityApi,
};